<ng-container *transloco="let t">
  <article class="seo-landing content-wrapper">
    <h1 class="home-heading">{{ copy('h1') }}</h1>
    <app-what-is-gap *ngIf="has('whatIsGap')"></app-what-is-gap>
    <app-benefits *ngIf="has('benefits')"></app-benefits>
    <app-for-who *ngIf="has('forWho')"></app-for-who>
    <app-when-to-buy *ngIf="has('whenToBuy')"></app-when-to-buy>
    <app-valid-vehicles *ngIf="has('vehicles')"></app-valid-vehicles>
    <app-faq *ngIf="has('faq')"></app-faq>
    <p class="seo-landing__cta">
      <a routerLink="/">{{ t('seo.landing.calculatorCta') }}</a>
    </p>
  </article>
</ng-container>
